<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { finalCtaData, brand } from '../../config/pageData.js';
import { logEvent } from '@/utils/firebase.js';
import { getButtonUrl } from '@/utils/channelConfig.js';
import { getLogEventClickParams } from '@/utils/logEventParams';

const route = useRoute();
const ctaUrl = computed(() => getButtonUrl('formSubmit', route.query.channel));

const onCtaClick = () => {
  logEvent('mobile_fengsuids_submit_click', getLogEventClickParams());
};
</script>

<template>
  <section class="m-final">
    <img
      :src="brand.logoLight"
      alt="楓燧堂"
      class="m-final-logo"
    />
    <h2 class="m-final-title">
      {{ finalCtaData.titleBefore }}
      <span class="m-gold">{{ finalCtaData.titleHighlight }}</span>
    </h2>
    <p class="m-final-desc">{{ finalCtaData.desc }}</p>
    <a
      :href="ctaUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="m-btn"
      @click="onCtaClick"
    >
      {{ finalCtaData.btnText }}
    </a>
    <div class="m-final-note">{{ finalCtaData.note }}</div>
  </section>
</template>

<style scoped lang="scss">
.m-final {
  background: linear-gradient(160deg, #22352b, #16241d);
  text-align: center;
  padding: 96px 32px;
  color: #f7f3ea;
}

.m-final-logo {
  display: block;
  width: 120px;
  height: 120px;
  margin: 0 auto 32px;
  opacity: 0.92;
}

.m-final-title {
  color: #fff;
  font-size: 44px;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 1px;
  white-space: nowrap;
}

.m-gold {
  color: #c9a25e;
}

.m-final-desc {
  color: #c9c3b1;
  margin: 22px auto 36px;
  font-size: 32px;
}

.m-btn {
  display: block;
  background: #c9a25e;
  color: #16241d;
  font-size: 34px;
  font-weight: 700;
  text-decoration: none;
  border-radius: 999px;
  letter-spacing: 2px;
  padding: 24px 0;
}

.m-final-note {
  font-size: 23px;
  color: #8d887a;
  margin-top: 24px;
  white-space: nowrap;
}
</style>
